import { WHY_CHOOSE_US } from "@/data/content";

export default function WhyChooseUs() {
  return (
    <section data-testid="why-section" className="py-20 sm:py-24 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl reveal">
          <p className="text-xs sm:text-sm font-bold uppercase tracking-[0.2em] text-primary">Why Choose Us</p>
          <h2 className="mt-3 font-heading font-bold text-3xl sm:text-4xl lg:text-5xl text-slate-900 leading-tight tracking-tight">
            Built for trust. Engineered for outcomes.
          </h2>
          <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed">
            Eight reasons India's leading enterprises and SMEs partner with Advance HR Technologies.
          </p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {WHY_CHOOSE_US.map(({ icon: Icon, title, text }, i) => (
            <div
              key={title}
              data-testid={`why-card-${i}`}
              className="group bg-white border border-slate-200 rounded-2xl p-6 hover:border-primary/40 hover:-translate-y-1 hover:shadow-lg shadow-sm transition-all duration-300 ease-out"
            >
              <div className="w-11 h-11 rounded-xl bg-primary/10 group-hover:bg-primary flex items-center justify-center mb-5 transition-colors">
                <Icon className="w-5 h-5 text-primary group-hover:text-white" strokeWidth={1.6} />
              </div>
              <h3 className="font-heading font-bold text-base text-slate-900">{title}</h3>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">{text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
